import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import valIsObject from 'scaleflow/utils/is-object';
import PersonValidations from 'scaleflow/validators/person';

export default class PeopleFormIndexComponent extends Component {
  @service router;
  @service store;

  personValidations = PersonValidations;

  @tracked teamFormIsVisible = false;
  @tracked roleFormIsVisible = false;

  @action
  goToListPage() {
    if (this.args.model.active)
      this.router.transitionTo('resources.people.active');
    else this.router.transitionTo('resources.people.inactive');
  }

  get isEdit() {
    return !!this.args.model.id;
  }

  @action
  validateProperty(changeset, property) {
    return changeset?.validate(property);
  }

  @action
  onSubmit(changeset, e) {
    e.preventDefault();
    changeset.validate().then(() => {
      changeset.save().then(() => {
        this.goToListPage();
      });
    });
  }

  @action
  setPersonStatus(changeset, checked) {
    changeset.set('active', checked);
  }

  @action
  teamIds(changeset) {
    const teams = changeset.get('teams');
    const isObject = valIsObject(teams);
    const isPromise = !isObject ? false : 'promise' in teams;
    if (isPromise && !teams?.content) return [];
    if (isPromise && teams?.content)
      return teams?.content.map((team) => team.id);
    return teams.map((team) => team.id);
  }

  @action
  setTeams(changeset, e) {
    const teams = e.map((team_id) => this.store.peekRecord('team', team_id));
    changeset.set('teams', teams);
  }

  @action
  roleIds(changeset) {
    const roles = changeset.get('roles');
    const isObject = valIsObject(roles);
    const isPromise = !isObject ? false : 'promise' in roles;
    if (isPromise && !roles?.content) return [];
    if (isPromise && roles?.content)
      return roles?.content.map((role) => role.id);
    return roles.map((role) => role.id);
  }

  @action
  setRoles(changeset, e) {
    const roles = e.map((role_id) => this.store.peekRecord('role', role_id));
    changeset.set('roles', roles);
  }

  @action
  toggleTeamForm() {
    this.teamFormIsVisible = !this.teamFormIsVisible;
  }

  @action
  toggleRoleForm() {
    this.roleFormIsVisible = !this.roleFormIsVisible;
  }

  @action
  onTeamAdded(changeset, team) {
    const currentTeams = this.teamIds(changeset).map((id) =>
      this.store.peekRecord('team', id),
    );
    currentTeams.push(team);
    changeset.set('teams', currentTeams);
  }

  @action
  onRoleAdded(changeset, role) {
    const currentRoles = this.roleIds(changeset).map((id) =>
      this.store.peekRecord('role', id),
    );
    currentRoles.push(role);
    changeset.set('roles', currentRoles);
  }

  @action
  cancelForm(changeset) {
    if (!changeset.isPristine) changeset.rollback();
    if (!this.isEdit) this.args.model.deleteRecord();
    this.goToListPage();
  }

  @action
  handleInput(changeset, e) {
    changeset.set(e.target.id, e.target.value);
  }

  get body() {
    return document.body;
  }
}
